import Vue from 'vue';
import VueI18n from 'vue-i18n';

import {
	messages
} from '../localization';

Vue.use(VueI18n);
// locale.use(de);

const i18n = new VueI18n({
	locale: 'de',
	messages
});

export {
	i18n
}